import { Plate } from '../components/Plate';
import { Reveal } from '../components/Reveal';
import { story } from '../content/wedding';

/**
 * The story, and the page it opens. Its section head carries the `<h1>`: the
 * page has no separate head of its own, because this one already names it.
 *
 * Each print is ~70% of the figure column — which is the full content width on
 * a phone, and a little over half of a 74rem shell from 52rem up. Both figures
 * are measured, not guessed; without them the browser assumes full-width and
 * pulls a source two steps too big.
 */
const SIZES = '(min-width: 52rem) 25rem, 63vw';

export function Story() {
  return (
    <section class="section" id="our-story">
      <div class="shell story__grid">
        <figure class="story__figure">
          <div class="diptych">
            {story.photos.map((photo, i) => (
              <Reveal key={photo.name} class={`diptych__frame diptych__frame--${i + 1}`} delay={i * 140}>
                <Plate name={photo.name} alt={photo.alt} sizes={SIZES} />
              </Reveal>
            ))}
          </div>
          <Reveal as="figcaption" delay={280}>
            {story.photoCaption}
          </Reveal>
        </figure>

        <div>
          <Reveal class="section-head" delay={80}>
            <span class="eyebrow">{story.eyebrow}</span>
            <h1>{story.title}</h1>
          </Reveal>
          <Reveal class="prose" delay={160}>
            {story.paragraphs.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
